import type { FC} from 'react';
import { memo } from 'react';

import type { Tag } from '@shared/types/common';
import { Checkbox } from '@shared/ui/inputs';
import { MenuDropdown, MenuItem, useCommonMenu } from '@shared/ui/menus';

import { ButtonTag } from './button-tag';

interface Props {
	value: number[];
	onChange: (tags: number[]) => void;
	error?: boolean;
	tags: Tag[];
	id?: string;
}

export const TagSelector: FC<Props> = memo(({ value = [], onChange, error, tags, id }) => {
	const { onOpen, setReferenceEl, referenceEl, popperEl, setPopperEl } = useCommonMenu();

	const handleChange = (id: number) => {
		const selectedTags = [...value];
		let updatedTags: number[] = [];
		const isSelected = !!selectedTags.find((tag) => tag === id);
		if (isSelected) {
			updatedTags = selectedTags.filter((tag) => tag !== id);
		} else {
			selectedTags.push(id);
			updatedTags = [...selectedTags];
		}
		onChange(updatedTags);
	};

	return (
		<div>
			<ButtonTag
				id={id ?? 'openMenu'}
				isOpen={value.length > 0}
				error={!!error}
				selected={value.length}
				onClick={onOpen}
				ref={setReferenceEl}
			/>
			<MenuDropdown referenceEl={referenceEl} popperEl={popperEl} setPopperEl={setPopperEl}>
				{tags.map((tag) => (
					<MenuItem
						key={tag.id}
						isActive={value.indexOf(tag.id) !== -1}
						onClick={() => handleChange(tag.id)}
					>
						<Checkbox checked={value.indexOf(tag.id) > -1} label={tag.title} />
					</MenuItem>
				))}
			</MenuDropdown>
		</div>
	);
});
